<template>
    <div class="dedication-root">
        <div class="content">
            <div class="header">
                <span>{{l10nBecomeAPartner}}</span>
            </div>
            <div class="divider"></div>
            <div class="subheader">
                <div>
                    <jabra-body-text-binding :html="l10nDedicationRootSubText"></jabra-body-text-binding>
                </div>
            </div>
            <div class="dedications-section">
                <div class="dedication-section">
                    <div class="dedication-content">
                        <div class="dedication-name">{{l10nDedication}}</div>
                        <div class="dedication-options">
                            <div class="dedication-option">
                                <div class="title-and-divider">
                                    <div class="dedication-title">
                                        <span>{{l10nAYearOfLearning}}</span>
                                    </div>
                                    <div class="dedication-divider-container">
                                        <div class="dedication-divider"></div>
                                    </div>
                                </div>
                                <div class="dedication-subtitle">
                                    <jabra-body-text-binding :content-class="dedicationClassStr"
                                                             :html="l10nDedicationYearOfLearningSubText"></jabra-body-text-binding>
                                </div>
                                <div class="dedication-actions">
                                    <jabra-btn v-on:jbr-click="navigateTo('dedicationYear')">
                                        <span class="dedicate-action-span">{{l10nSponsorYear}}</span>
                                    </jabra-btn>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="dedication-section middle-dedication">
                    <div class="dedication-content middle-dedication">
                        <div class="dedication-name">{{l10nDedication}}</div>
                        <div class="dedication-options">
                            <div class="dedication-option">
                                <div class="title-and-divider">
                                    <div class="dedication-title">
                                        <span>{{l10nADayOfLearning}}</span>
                                    </div>
                                    <div class="dedication-divider-container">
                                        <div class="dedication-divider"></div>
                                    </div>
                                </div>
                                <div class="cost">
                                    <!--<span>80$</span>-->
                                </div>
                                <div class="dedication-subtitle middle-dedication">
                                    <jabra-body-text-binding :content-class="dedicationClassStr"
                                                             :html="l10nDedicationDayOfLearningSubText"></jabra-body-text-binding>
                                </div>
                                <div class="dedication-actions">
                                    <jabra-btn dark v-on:jbr-click="navigateTo('dedicationDay')">
                                        <span class="dedicate-action-span">{{l10nSponsorDay}}</span>
                                    </jabra-btn>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="dedication-section">
                    <div class="dedication-content">
                        <div class="dedication-name">{{l10nDedication}}</div>
                        <div class="dedication-options">
                            <div class="dedication-option">
                                <div class="title-and-divider">
                                    <div class="dedication-title">
                                        <span>{{l10nLimudOfOneMasechetDuringAYear}}</span>
                                    </div>
                                    <div class="dedication-divider-container">
                                        <div class="dedication-divider"></div>
                                    </div>
                                </div>
                                <div class="dedication-subtitle">
                                    <jabra-body-text-binding :content-class="dedicationClassStr"
                                                             :html="l10nDedicationLimudOfOneMasechetDuringAYearSubText"></jabra-body-text-binding>
                                </div>
                                <div class="dedication-actions">
                                    <jabra-btn v-on:jbr-click="navigateTo('dedicationMasechet')">
                                        <span class="dedicate-action-span">{{l10nSponsorMasechet}}</span>
                                    </jabra-btn>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="bottom-colored-section-container">
            <div class="bottom-colored-section">
            </div>
        </div>
    </div>

</template>

<script>

    import helpers from '../services/helpers'


    export default {
        name: 'dedication-root-component',
        data: function () {
            return {}
        },
        computed: {
            l10nBecomeAPartner() {
                return this.l10nGetter('become_a_partner')
            },
            l10nDedicationRootSubText() {
                return this.l10nBodyGetter('dedication_root_sub_text')
            },
            l10nDedication() {
                return this.l10nGetter('dedication')
            },
            l10nAYearOfLearning() {
                return this.l10nGetter('a_year_of_learning')
            },
            l10nDedicationYearOfLearningSubText() {
                return this.l10nBodyGetter('dedication_year_of_learning_sub_text')
            },
            dedicationClassStr() {
                return 'dedication-subtitle'
            },
            l10nSponsorYear() {
                return this.l10nGetter('sponsor_year')
            },
            l10nADayOfLearning() {
                return this.l10nGetter('a_day_of_learning')
            },
            l10nDedicationDayOfLearningSubText() {
                return this.l10nBodyGetter('dedication_day_of_learning_sub_text')
            },
            l10nSponsorDay() {
                return this.l10nGetter('sponsor_day')
            },
            l10nLimudOfOneMasechetDuringAYear() {
                return this.l10nGetter('limud_of_one_masechet_during_a_year')
            },
            l10nDedicationLimudOfOneMasechetDuringAYearSubText() {
                return this.l10nBodyGetter('dedication_limud_of_one_masechet_during_a_year_sub_text')
            },
            l10nSponsorMasechet() {
                return this.l10nGetter('sponsor_masechet')
            },
        },
        methods: {
            navigateTo(routeName) {
                this.$router.push({name: routeName})
            },
            l10nGetter(key) {
                return helpers.uiTextGetter(this.$store, key)
            },
            l10nBodyGetter(key) {
                return helpers.bodyTextGetter(this.$store, key)
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "../scss/main";

    .dedication-root {
        background-image: url("../assets/images/dedication-bg.png");
        background-repeat: no-repeat;
        background-size: 800px 800px;
        background-position: top;
    }

    .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        max-width: 1600px;
        padding: 70px 0px 130px;
        margin: 0 auto;
    }

    .header {
        text-transform: uppercase;
        @include font-abraham(50px, $font-color-blue, 400);
        margin: 0 0 20px 0;
    }

    .subheader {
        text-align: center;
        @include font-abraham(30px, $font-color-blue, 300);
        margin: 0 0 20px 0;
    }

    .divider {
        width: 120px;
        height: 8px;
        margin: 30px;
        background: $accent-1;
    }

    .dedication-divider-container {
        display: flex;
        justify-content: center;

        .dedication-divider {
            width: 58px;
            height: 8px;
            margin: 10px;
            background: $accent-1;
        }
    }

    .dedications-section {
        padding: 220px 10px 10px;
        display: flex;
        width: 100%;
        justify-content: space-around;
        align-items: center;

        .dedication-section {
            border-left: $accent-1 solid 2px;
            box-shadow: 5px 0 10px 0 $grey-2;
            background: white;
            width: 28%;

            &.middle-dedication {
                width: 33%;
            }

        }
    }

    .dedication-content {
        padding: 0 50px;
        &.middle-dedication {
            padding: 0 60px;
            /*padding: 0 105px;*/
        }
    }

    .dedication-name {
        display: flex;
        justify-content: center;
        @include font-abraham(20px, $font-color-blue, 400);
        padding: 32px 0 0 0;
    }

    .title-and-divider {
        min-height: 220px;
    }

    .dedication-title {
        display: flex;
        justify-content: center;
        text-align: center;
        @include font-abraham(50px, $font-color-blue, 400);
        padding: 20px 0 0 0;
        text-transform: uppercase;
    }

    .dedication-options {
        display: flex;
        justify-content: space-around;
    }

    .dedication-option {
    }

    .cost {
        display: flex;
        justify-content: center;
        @include font-abraham(75px, $accent-1, 400);
        padding: 40px 0 0 0;
    }

    .dedication-subtitle {
        @include font-abraham(18px, $font-color-lighter-blue, 300);
        text-align: center;
        min-height: 64px;
        padding: 45px 0 15px 0;
        &.middle-dedication {
            padding: 15px 0;
        }
    }

    .dedication-actions {
        display: flex;
        justify-content: center;
        padding: 47px 0;
    }

    .dedicate-action-span {
        font-size: 20px;
        line-height: 50px;
        padding: 0 30px;
        white-space: nowrap;
    }

    .bottom-colored-section-container {
        z-index: -1;
        position: relative;
    }

    .bottom-colored-section {
        background: rgb(220, 233, 239);
        height: 294px;
        width: 100%;
        position: absolute;
        bottom: 0;
    }

</style>
